module.controller('headerWrapCtrl', ['$scope', '$state', function ($scope, $state) {

  var vm = this;

  $scope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
    vm.removeBkg = $state.current.data.noBkgHeader;
    vm.secondaryLinks = $state.current.data.headerSecondaryLinks;
  });

}]);
